/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/
import { userAgentDetection } from "common/common-util-functions";

const defaultState = {
  themeName: "orangeTheme",
  PostList: [],
  symptomsList: [],
  diseaseList: [],
  clinicalFeaturesList: [],
  helpMenuData:[],
  secondaryFindingsList: [],
  differentialDiagnosisList: [],
  orgzFeatures: null,
  diagnosticTests: [],
  recommendations: [],
  speedData: {},
  userAgentData: userAgentDetection(),
  isLogOutPopUpModel: false,
  isHelpMenuPopUpModel: false,
  versionInfo:{},
  isLoginPopUpModel: false,
  reportContent: [],
  showPortalModal: false,
  allowedUrlsList: [],
};

const featuresWhichArentPages = [
  "report_download",
  "report_share",
  "trigger_review_for_patient",
  "trigger_review_for_image",
];

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_REPORT_CONTENT_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "GET_REPORT_CONTENT_FULFILLED": {
      return {
        ...state,
        reportContent: action.payload.data,
        loading: false,
        errors: {},
      };
    }
    case "GET_REPORT_CONTENT_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload.message },
      };
    }
    // model
    case "GET_MODEL_DATA_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "GET_MODEL_DATA_FULFILLED": {
      return {
        ...state,
        session: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "GET_MODEL_DATA_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload.message },
      };
    }
    // netSpeed test
    case "GET_NET_SPEED_FULFILLED": {
      return {
        ...state,
        speedData: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "GET_NET_CONNECTIVITY_FULFILLED": {
      return {
        ...state,
        connection: action.payload,
        loading: false,
        errors: {},
      };
    }
    // stores
    case "GET_ALL_SYMPTOMS_LIST_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "GET_ALL_SYMPTOMS_LIST_FULFILLED": {
      return {
        ...state,
        symptomsList: action.payload.data,
        loading: false,
        errors: {},
      };
    }
    case "GET_ALL_SYMPTOMS_LIST_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload.message },
      };
    }
    case "GET_THEME_DATA": {
      return {
        ...state,
        themeName: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "UPDATE_USER_AGENT_DATA": {
      return {
        ...state,
        userAgentData: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "UPDATE_LOGOUT_MODEL": {
      return {
        ...state,
        isLogOutPopUpModel: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "UPDATE_HELP_MENU_MODEL": {
      return {
        ...state,
        isHelpMenuPopUpModel:action.payload,
        loading: false,
        errors: {}
      }
    }
    case "UPDATE_LOGIN_MODEL": {
      return {
        ...state,
        isLoginPopUpModel: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "CHANGE_PORTAL_MODAL_STATE": {
      return {
        ...state,
        showPortalModal: action.payload,
      };
    }
    case "SET_DISEASE_LIST": {
      return {
        ...state,
        diseaseList: action.payload,
      };
    }
    case "SET_CLINICAL_FEATURES_LIST": {
      return {
        ...state,
        clinicalFeaturesList: action.payload,
      };
    }
    case "SET_HELP_MENU_DATA":{
      return {
        ...state,
        helpMenuData:action.payload,
      }
    }
    case "SET_DIFFERENTIAL_DIAGNOSIS_LIST": {
      return {
        ...state,
        differentialDiagnosisList: action.payload,
      };
    }

    case "SET_SECONDARY_FINDINGS_LIST": {
      return {
        ...state,
        secondaryFindingsList: action.payload,
      };
    }
    case "GET_ORGZ_FEATURES": {
      const featuresThatArePages = Object.entries({ ...action.payload }).filter(
        ([feature, value]) => {
          if (
            Number(value) === 1 &&
            !featuresWhichArentPages.includes(feature)
          ) {
            return true;
          }
          return false;
        }
      );
      if (action.payload?.isCurrentUserAConsultant)
        return {
          ...state,
          orgzFeatures: action.payload,
          allowedUrlsList: ["/doctor-review"],
        };
      const allowedUrlsList = featuresThatArePages
        .map(([page]) => {
          if (page === "patient_upload") {
            return "/patients";
          } else if (page === "view_patient") {
            return "/view-patients";
          } else if (
            page == "bulk_upload" ||
            page === "bulk_upload_for_patient"
          ) {
            return "/bulk-upload";
          } else if (page === "view_images") {
            return "/view-images";
          } else if (page === "review_images") {
            return "/review-images";
          } else if (page === "review_patients") {
            return "/review-patients";
          } else if (
            page === "doc_annotation_patient" &&
            action.payload?.isCurrentUserAConsultant
          ) {
            return "/doctor-review";
          } else if (page === "view_patients_from_bulk_upload") {
            return "/view-patients-bu";
          }
        })
        .filter((page) => page);
      return {
        ...state,
        orgzFeatures: action.payload,
        allowedUrlsList,
      };
    }
    case "SET_DIAGNOSTIC_TESTS_LIST": {
      return {
        ...state,
        diagnosticTests: action.payload,
      };
    }
    case "SET_HELP_MENU_DATA_LIST": {
      return {
        ...state,
        versionInfo: action.payload,
      }
    }
    case "SET_RECOMMENDATIONS_LIST": {
      return {
        ...state,
        recommendations: action.payload,
      };
    }

    default:
      return state;
  }
  return state;
};
